export const CARA_OPEN_REQUEST_EVENT = 'caraOpenRequest';
//# sourceMappingURL=cara.js.map